export enum PAGE_ROUTES {
    GET = 'page?handle=:handle',
    ALL_PAGES = "/page/all",
    CREATE = "/page/create",
    UPDATE = "/page/update",
    DELETE = "/page/delete",
    FOLLOW = "/page/follow",
    FOLLOWERS = "/followers",
}